export const RESERVATION_CANCELED = 1;
export const ANY_BARBER = 'any';
export const ANY_SERVICE = 'any';
export const TIME_WAITING_LIST = 'waiting-list';
export const TIP_NONE = 0;

export const STEPS = {
  barber: 'barber',
  service: 'service',
  time: 'time',
  reservation: 'reservation',
};
export const SHOP_TYPE = {
  rental: 0,
  commission: 1,
};

export const OWNER_TYPE = {
  shop: 'shop',
  barber: 'barber',
  brand: 'brand',
};

export const LADY_CLIPPER_SHOP_ID = '19f2f108-9243-41d3-9049-9f7589d9f1a0';
export const KRWN_ZAZZ_PLACE_STE_FOY_SHOP_ID = '2f179764-f13b-4477-b880-768151a184e5';

// for testing purposes use different shop ids for different environments
export const CHOP_MURRAY_HILL_SHOP_ID = (() => {
  switch (process.env.WEB_ENV) {
    case 'development': return '88e536e3-81ef-4e73-842c-1008dc824c76';
    case 'qa':
    case 'production': return '9fcfca0c-9a8c-4ee2-8642-23f83d61f519';
    case 'staging': return 'f307a95d-c7b5-4db1-8052-e6100db1acd3';
    default: return '9fcfca0c-9a8c-4ee2-8642-23f83d61f519';
  }
})();

export const SQUIRE_FEE_SHOPS = [
  // Braid
  '0a6c88fd-15b5-4b1d-afba-15a241e30439',
  '0614c9c3-6b4b-400f-a52f-45f6766c7fc5',
  // Empire
  '34210d35-6048-4c0b-9157-5c05d476017a',
  'dca00d00-1b39-41b8-a4b2-082049065c1c',
];
export const NO_PROMO_BOX_SHOPS = [
  // Monthly
  '7f105e43-206c-4c69-80c1-3a6168dbdedd',
  '2999973c-dfbd-4116-af3a-f9b4b0dd48b8',
  '764e8cee-292c-4399-9a31-3311c41af109',
  '76765d07-6aa4-46b8-8201-821f863ded5c',
  '3afb06db-a395-4dd1-b22f-1cb772f54e2e',
];

// Actions
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_REDIRECTION = 'SET_REDIRECTION';
export const CLEAR_REDIRECTION = 'CLEAR_REDIRECTION';
export const BAD_ROUTE = 'BAD_ROUTE';
export const CLEAR_SHOPS = 'CLEAR_SHOPS';
export const CLEAR_BARBERS = 'CLEAR_BARBERS';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const CLEAR_RESERVATIONS = 'CLEAR_RESERVATIONS';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const MAINTENANCE_MODE = 'MAINTENANCE_MODE';
export const RECEIVE_CITIES = 'RECEIVE_CITIES';
export const REQUEST_CITIES = 'REQUEST_CITIES';
export const RECEIVE_SHOPS = 'RECEIVE_SHOPS';
export const RECEIVE_SHOP = 'RECEIVE_SHOP';
export const REQUEST_SHOP = 'REQUEST_SHOP';
export const REQUEST_SHOPS = 'REQUEST_SHOPS';
export const REQUEST_BARBERS = 'REQUEST_BARBERS';
export const REQUEST_BARBER = 'REQUEST_BARBER';
export const RECEIVE_BARBERS = 'RECEIVE_BARBERS';
export const RECEIVE_BARBER = 'RECEIVE_BARBER';
export const RECEIVE_BARBERS_TIMES = 'RECEIVE_BARBERS_TIMES';
export const CLEAR_BARBER_AVAILABILITY = 'CLEAR_BARBER_AVAILABILITY';
export const REQUEST_BARBER_AVAILABILITY = 'REQUEST_BARBER_AVAILABILITY';
export const RECEIVE_BARBER_AVAILABILITY = 'RECEIVE_BARBER_AVAILABILITY';
export const REQUEST_SERVICES = 'REQUEST_SERVICES';
export const RECEIVE_SERVICES = 'RECEIVE_SERVICES';
export const REQUEST_SERVICE = 'REQUEST_SERVICE';
export const RECEIVE_SERVICE = 'RECEIVE_SERVICE';
export const ALL_SERVICES_FETCHED = 'ALL_SERVICES_FETCHED';
export const SET_ACTIVE_DAY = 'SET_ACTIVE_DAY';
export const SET_ACTIVE_TIME = 'SET_ACTIVE_TIME';
export const SET_ACTIVE_TIME_BARBER = 'SET_ACTIVE_TIME_BARBER';
export const RESET_TIP = 'RESET_TIP';
export const SET_TIPS = 'SET_TIPS';
export const SET_TIP = 'SET_TIP';
export const SET_CUSTOM_TIP = 'SET_CUSTOM_TIP';
export const SET_SERVICES = 'SET_SERVICES';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_TOTAL_WITHOUT_TIP_AND_FEES = 'SET_TOTAL_WITHOUT_TIP_AND_FEES';
export const ADD_FIELD = 'ADD_FIELD';
export const TOUCH_FIELD = 'TOUCH_FIELD';
export const VALIDATE_FIELD = 'VALIDATE_FIELD';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const RESET_FIELDS = 'RESET_FIELDS';
export const CREATE_RESERVATION = 'CREATE_RESERVATION';
export const REQUEST_RESERVATION = 'REQUEST_RESERVATION';
export const RECEIVE_RESERVATION = 'RECEIVE_RESERVATION';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const REQUEST_BARBER_AVAILABLE_TIME = 'REQUEST_BARBER_AVAILABLE_TIME';
export const RECEIVE_BARBER_AVAILABLE_TIME = 'RECEIVE_BARBER_AVAILABLE_TIME';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const CONFIRM_BARBER = 'CONFIRM_BARBER';
export const USER_TOKEN_ERROR = 'USER_TOKEN_ERROR';
export const USER_TOKEN_SUCCESS = 'USER_TOKEN_SUCCESS';
export const VERIFY_PASSWORD = 'VERIFY_PASSWORD';
export const VERIFY_PASSWORD_SUCCESS = 'VERIFY_PASSWORD_SUCCESS';
export const VERIFY_PASSWORD_ERROR = 'VERIFY_PASSWORD_ERROR';
export const PROCESS_PAYMENT = 'PROCESS_PAYMENT';
export const PROCESS_PAYMENT_SUCCESS = 'PROCESS_PAYMENT_SUCCESS';
export const RESET_PROCESS_PAYMENT = 'RESET_PROCESS_PAYMENT';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const CHECK_TIME_AVAILABLE = 'CHECK_TIME_AVAILABLE';
export const TIME_AVAILABLE = 'TIME_AVAILABLE';
export const TIME_UNAVAILABLE = 'TIME_UNAVAILABLE';
export const VALIDATING_APPT_REQUEST_STARTED = 'VALIDATING_APPT_REQUEST_STARTED';
export const VALIDATING_APPT_REQUEST_FINISHED = 'VALIDATING_APPT_REQUEST_FINISHED';
export const FAILED_CHARGES = 'FAILED_CHARGES';
export const FAILED_BOOK_AND_RESERVE = 'FAILED_BOOK_AND_RESERVE';
export const SET_APPLE_PAY = 'SET_APPLE_PAY';
export const RESET_PROMO_CODE = 'RESET_PROMO_CODE';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_GIFT_CARD_CODE = 'SET_GIFT_CARD_CODE';
export const FETCH_PROMO_CODE = 'FETCH_PROMO_CODE';
export const INVALID_PROMO_CODE = 'INVALID_PROMO_CODE';
export const RESET_FEE = 'RESET_FEE';
export const FETCH_FEE = 'FETCH_FEE';
export const ADD_CUSTOMER_TO_WAITING_LIST = 'ADD_CUSTOMER_TO_WAITING_LIST';
export const BOOK_APPOINTMENT_TIME_SLOT = 'BOOK_APPOINTMENT_TIME_SLOT';
export const BOOK_APPOINTMENT_TIME_SLOT_SUCCESS = 'BOOK_APPOINTMENT_TIME_SLOT_SUCCESS';
export const REMOVE_CUSTOMER_FROM_WAITING_LIST = 'REMOVE_CUSTOMER_FROM_WAITING_LIST';
export const REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS = 'REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS';
export const CONFIRM_BARBER_SUCCESS = 'CONFIRM_BARBER_SUCCESS';
export const FETCH_RECEIPT = 'FETCH_RECEIPT';
export const FETCH_RECEIPT_SUCCESS = 'FETCH_RECEIPT_SUCCESS';
export const CLEAR_WAITING_LIST_INFO = 'CLEAR_WAITING_LIST_INFO';
export const SET_WAITING_LIST_INFO = 'SET_WAITING_LIST_INFO';
export const CLEAR_WAITING_LIST_TIMES = 'CLEAR_WAITING_LIST_TIMES';
export const SET_WAITING_LIST_TIMES = 'SET_WAITING_LIST_TIMES';
export const FETCH_CAMPAIGN = 'FETCH_CAMPAIGN';
export const FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';
export const CAMPAIGN_UNSUBSCRIBE = 'CAMPAIGN_UNSUBSCRIBE';
export const CAMPAIGN_UNSUBSCRIBE_SUCCESS = 'CAMPAIGN_UNSUBSCRIBE_SUCCESS';
export const CAMPAIGN_UNSUBSCRIBE_ERROR = 'CAMPAIGN_UNSUBSCRIBE_ERROR';
export const REQUEST_DAYS_OFF = 'REQUEST_DAYS_OFF';
export const RECEIVE_DAYS_OFF = 'RECEIVE_DAYS_OFF';
export const SET_PROCESSING = 'SET_PROCESSING';
export const RESCHEDULE_INVALID_PROMO_ERROR = 'RESCHEDULE_INVALID_PROMO_ERROR';
export const SET_TAX_BREAKDOWN = 'SET_TAX_BREAKDOWN';
export const RESET_PROMO_ERROR = 'RESET_PROMO_ERROR';
export const REMOVE_PROMO_FROM_RESERVATION = 'REMOVE_PROMO_FROM_RESERVATION';
export const THIRD_PARTY_PROMO = 'THIRD_PARTY_PROMO';
export const SET_MEMBERSHIP_DISCOUNTS = 'SET_MEMBERSHIP_DISCOUNTS';



// WEBPACK FOOTER //
// ./src/app/constants.js